/*jshint esversion: 6 */

import * as types from './mutation-types'
import { debounce } from "lodash";


const debouncedUpdateItem = debounce(updateCartItem,300);


/**
 * fetch shop info
 */
export const fetchShopInfo = ({commit, dispatch, state}, data = {}) => {
    return new Promise((resolve,reject) => {

        const alias = data.alias || window.company_alias;
        const date  = data.date || null;
        const locale = window.language;

        $.getJSON(route('webapp.ordering.shop-info',{alias,date,locale}),(response) => {
          commit(types.SET_SHOP_INFO, response);
          resolve(response);
        });

    });
}

export const fetchPaymentMethods = ({commit, dispatch, state}, data = {}) => {
    return new Promise((resolve,reject) => {

        const alias = data.alias || window.company_alias;
        const shippingMethodId = data.shippingMethodId;

          $.getJSON(route('webapp.shop.shipping-method.payments', {alias, id : shippingMethodId}),(response) => {
            if(response.status == 'ok'){
                Vue.set(state.shopInfo,'paymentMethods',response.paymentMethods);
              resolve(response.paymentMethods);
            }

            if(response.status == 'error'){
                Vue.set(state.shopInfo,'paymentMethods',[]);
                 resolve(response);
            }
          });
    });
}

/**
 * checkout 
 * personal info
 * shipping info
 * payment info
 */
export const fetchCheckoutInfo = ({commit, dispatch, state}, data = {}) => {
    return new Promise((resolve,reject) => {

        const alias = data.alias || window.company_alias;
        const locale = window.language;

        $.getJSON(route('webapp.ordering.checkout-info',{alias,locale}),(response) => {
          commit(types.SET_CHECKOUT_INFO, response.data);
          resolve(response.data);
        });

    });
}

/**
 * Initialize cart from local storage
 */
export const initCart = ({commit, dispatch, state}, alias) => {
    return new Promise((resolve,reject) => {

        const locale = window.language;
        $.getJSON(route('webapp.shop.cart.index',{alias,locale}),(cart) => {
            commit(types.SET_CART, cart);
            resolve(cart);
        });

    })

}


/**
 * Add an item to cart
 */
export const addItemToCart = ({commit, dispatch, state}, data) => {

    return new Promise((resolve,reject) => {
        const locale = window.language;
        const alias  = window.company_alias;

        $.ajax({
            type: 'POST',
            url: route('webapp.shop.cart.add',{alias,locale}),
            data: {
                item_id: data.item.id,
                variant_id: data.variant ? data.variant.id : data.item.variant_id,
                options : data.options.map(x => x.id),
                comments: data.comments,
                quantity: data.quantity,
            },
            success(response){
                if(response.status == 'ok'){
                    const event = new CustomEvent('cart-changed',{detail: response.cart});
                    document.dispatchEvent(event);
                    commit(types.SET_CART, response.cart);
                    resolve(response.cart)
                }

                if(response.status == 'error'){
                    toastr.error(response.message);
                }
            },
            error(error){
                reject(error)
            }
        });
    });
}

/**
 * Remove item from cart by index
 */
export const removeItemFromCart = ({commit, dispatch, state}, index) => {
    state.cart.items.splice(index,1);
    return debouncedUpdateItem(commit,index,0);
}



/**
 * Cart item increase quantity
 */
export const increaseQuantity = ({commit, dispatch, state}, index) => {
    var cartItem = state.cart.items[index];
    var newQuantity = Number(cartItem.quantity) + 1
    cartItem.quantity = newQuantity
    state.cart.items[index] = cartItem;

    return debouncedUpdateItem(commit,index,newQuantity);
}

/**
 * Cart item decrease quantity
 */
export const decreaseQuantity = ({commit, dispatch, state}, index) => {
    var cartItem = state.cart.items[index];

    var newQuantity = Number(cartItem.quantity) - 1
    cartItem.quantity = newQuantity
    state.cart.items[index] = cartItem;
    return debouncedUpdateItem(commit,index,newQuantity);

}



/**
 * Clear cart
 */
export const clearCart = ({commit, dispatch, state}) => {

    state.cart.items = [];
    
    return new Promise((resolve,reject) => {
        const locale = window.language;
        const alias  = window.company_alias;

        $.ajax({
            type: 'POST',
            url: route('webapp.shop.cart.clear',{alias,locale}),
            data: {},
            success(response){
                const event = new CustomEvent('cart-changed',{detail: response.cart});
                document.dispatchEvent(event);
                commit(types.SET_CART, response.cart);
                resolve(response.cart)
            },
            error(error){
                reject(error)
            }
        });
    });
}

/**
 * Apply discount using discount code (coupon)
 */
export const applyCoupon = ({ commit, dispatch, state }, { couponCode, customerEmail }) => {
    const alias = window.company_alias;

    if (!couponCode) {
        return;
    }
    return new Promise((resolve, reject) => {

        $.ajax({
            type: 'POST',
            url: route('webapp.shop.cart.apply-coupon', alias),
            data: { coupon_code: couponCode, customer_email: customerEmail },
            success(response) {
                if (response.status === 'error') {
                    toastr.error(response.message);
                    resolve(false); // Coupon application failed.
                } else if (response.status === 'ok') {
                    commit(types.SET_CART, response.cart);
                    resolve(true); // Coupon applied successfully.
                }
            },
            error(error) {
                console.log(error);
                reject(error);
            }
        });
    });
}


/**
 * Remove cart coupon by index
 */
export const removeCoupon = ({commit, dispatch, state},index) => {
    
    const alias  = window.company_alias;
    return new Promise((resolve,reject) => {
        $.ajax({
          type: 'POST',
          url: route('webapp.shop.cart.remove-coupon',alias),
          data: {index},
          success(response){
            if(response.status == 'error') 
              toastr.error(response.message);

            if(response.status == 'ok'){
                commit(types.SET_CART, response.cart);
                resolve(response.cart)
            }

          },
          error(error){
            console.log(error)
            reject(error);
          }
        })
    });
}



//----- HELPERS -------------------------------/
function updateCartItem(commit,index,quantity){

    return new Promise((resolve,reject) => {
        const locale = window.language;
        const alias  = window.company_alias;

        $.ajax({
            type: 'POST',
            url: route('webapp.shop.cart.update',{alias,locale}),
            data: {index,quantity},
            success(response){

                const event = new CustomEvent('cart-changed',{detail: response.cart});
                document.dispatchEvent(event);

                if(response.status == 'ok'){
                    commit(types.SET_CART, response.cart);
                    resolve(response.cart)
                }

                if(response.status == 'error'){
                    commit(types.SET_CART, response.cart);
                    resolve(response.cart)
                    toastr.error(response.message);
                }
            },
            error(error){
                reject(error)
            }
        });
    });
}


